/**
 * Compact summary card used inside the New Order form once a customer has
 * been picked. Locked-down: editing customer data must happen in /customers
 * (single source of truth). Shows a warning state if the picked customer
 * lacks a phone number — backend will reject the order otherwise.
 */
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export function OrderCustomerCard({ customer, onClear }) {
  const missingPhone = !(customer.phone || "").trim();
  return (
    <div
      className={`border rounded-sm p-3 ${missingPhone ? "border-amber-300 bg-amber-50" : "border-emerald-200 bg-emerald-50/40"}`}
      data-testid="order-customer-card"
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="font-bold text-slate-900 truncate" data-testid="order-customer-name">
            {customer.nombre_facturacion}
          </p>
          {customer.nombre_fantasia && (
            <p className="text-xs text-slate-600 truncate">{customer.nombre_fantasia}</p>
          )}
          <div className="grid grid-cols-2 gap-x-3 mt-1.5 text-[11px] text-slate-600">
            <span>
              <span className="text-slate-400">Tel:</span>{" "}
              <span className={missingPhone ? "text-amber-700 font-bold italic" : "mono"} data-testid="order-customer-phone">
                {customer.phone || "FALTA TELÉFONO"}
              </span>
            </span>
            {customer.cedula && <span className="mono"><span className="text-slate-400">ID</span> {customer.cedula}</span>}
            {customer.address && <span className="col-span-2 truncate">Dir: {customer.address}</span>}
            {(customer.provincia || customer.canton) && (
              <span className="col-span-2 truncate text-slate-500">
                {[customer.provincia, customer.canton, customer.distrito].filter(Boolean).join(" / ")}
              </span>
            )}
          </div>
        </div>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          onClick={onClear}
          className="rounded-sm text-slate-500 hover:text-slate-900"
          data-testid="order-customer-clear"
          title="Elegir otro cliente"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      {missingPhone && (
        <div className="mt-2 flex items-center justify-between gap-2">
          <p className="text-[11px] text-amber-800 font-medium">
            Este cliente no tiene telefono. No se puede facturar sin contacto.
          </p>
          <a
            href="/customers"
            className="text-[11px] font-bold text-[#002FA7] hover:underline whitespace-nowrap"
            data-testid="order-customer-complete-link"
          >
            Completar datos
          </a>
        </div>
      )}
    </div>
  );
}
